// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import Promise from 'bluebird';

import { Analytics } from '@trello/atlassian-analytics';
import { forTemplate } from '@trello/i18n';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { showFlag } from '@trello/nachos/experimental-flags';

import { ninvoke } from 'app/scripts/lib/util/ninvoke';
import { pastedFileName } from 'app/scripts/views/internal/pastedFileName';
import { warnIfFileTooLarge } from 'app/scripts/views/internal/warnIfFileTooLarge';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
const format = forTemplate('card_detail_view_attachment');

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dragenter = function (this: any, e: any) {
  if (!this.model.editable()) {
    return;
  }

  const _height = this.$el.outerHeight();

  const limited = !this.model.canAttach();
  const restricted = !this.model.canDropAttachment(e.type);
  const className = restricted
    ? '.list-card-dropzone-restricted'
    : limited
    ? '.list-card-dropzone-limited'
    : '.list-card-dropzone';
  $(className, this.$el).css({
    height: `${_height}px`,
    'line-height': `${_height}px`,
  });

  return this.$el
    .addClass('is-drophover')
    .toggleClass('is-restricted', restricted)
    .toggleClass('is-limited', limited);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dragleave = function (this: any, e: any) {
  return this.$el.removeClass('is-drophover');
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dropFiles = function (this: any, e: any) {
  if (
    !this.model.canAttach() ||
    this.model.attachmentTypeRestricted('computer')
  ) {
    showFlag({
      id: 'observerCannotAttach',
      appearance: 'error',
      title: format('couldnt-attach-file'),
      description: format('you-dont-have-permission-to-attach-files'),
    });

    // Stop the event so we don't create a new card with the files
    stopPropagationAndPreventDefault(e);
    return;
  }

  const files = e.detail;

  if (warnIfFileTooLarge(this.model.getBoard(), files)) {
    return;
  }

  Promise.resolve(files)
    .each((file) => {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const name = file.name || pastedFileName();

      const source = 'cardViewAttachment';

      const analyticsPayload = {
        source,
        taskName: 'create-attachment/file',
      };

      // @ts-expect-error TS(2345): Argument of type '{ source: string; taskName: stri... Remove this comment to see the full error message
      const traceId = Analytics.startTask(analyticsPayload);
      // @ts-expect-error TS(2339): Property 'traceId' does not exist on type '{ sourc... Remove this comment to see the full error message
      analyticsPayload.traceId = traceId;

      return ninvoke(this.model, 'upload', file, name, { traceId }).then(
        (result) => {
          if (traceId) {
            Analytics.sendTrackEvent({
              source,
              action: 'uploaded',
              actionSubject: 'attachment',
              actionSubjectId: 'fileAttachment',
              attributes: {
                taskId: traceId,
              },
            });

            // @ts-expect-error TS(2345): Argument of type '{ source: string; taskName: stri... Remove this comment to see the full error message
            Analytics.taskSucceeded(analyticsPayload);
          }

          return result;
        },
        (err) => {
          if (traceId) {
            // @ts-expect-error TS(2339): Property 'error' does not exist on type '{ source:... Remove this comment to see the full error message
            analyticsPayload.error = err;
            // @ts-expect-error TS(2345): Argument of type '{ source: string; taskName: stri... Remove this comment to see the full error message
            Analytics.taskFailed(analyticsPayload);
          }

          return Promise.reject(err);
        },
      );
    })
    .catch(() => Alerts.show('unable to upload file', 'error', 'upload', 5000))
    .done();

  return e.stopPropagation();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dropUrl = function (this: any, e: any) {
  if (!this.model.canAttach() || this.model.attachmentTypeRestricted('link')) {
    // Stop the event so we don't create a new card with the files
    stopPropagationAndPreventDefault(e);
    return;
  }

  const url = e.detail;

  const board = this.model.getBoard();
  if (board.attachmentUrlRestricted(url)) {
    return;
  }

  this.model.uploadUrl(url);

  return e.stopPropagation();
};

export { dragenter, dragleave, dropFiles, dropUrl };
